import { DateToday } from '../../../constants/functions';

export function roundToNearestHour(date) {
   // date.setMinutes(date.getMinutes() + 30);
   // date.setMinutes(0, 0, 0);
   date.setMinutes(Math.ceil(date.getMinutes() / 30) * 30);

   return date;
}

export const myEventsList = [
   {
      id: 'randomstringg1',
      title: 'Event 1',
      host: {
         name: 'Tim Smith',
         uid: 'props.bookingForm.user.uid',
      },
      start: new Date(2022, 4, 5, 9, 30, 0),
      end: new Date(2022, 4, 5, 10, 30, 0),
      seats: 3,
      internalParticipants: null,
      externalGuests: null,
      catering: '',
      it: '',
   },
   {
      id: 'randomstringg2',
      title: 'Event 3',
      host: {
         name: 'props.bookingForm.user.name.firstName + props.bookingForm.user.name.lastName',
         uid: 'props.bookingForm.user.uid',
      },
      start: new Date(2022, 4, 5, 9, 30, 0),
      end: new Date(2022, 4, 5, 10, 30, 0),
      seats: 3,
      internalParticipants: null,
      externalGuests: null,
      catering: '',
      it: '',
   },
];

function diff_minutes(dt2, dt1) {
   var diff = (dt2.getTime() - dt1.getTime()) / 1000;
   diff /= 60;
   return Math.abs(Math.round(diff));
}

export function calculateAvailability(bookings, date) {
   console.log(bookings, 'result data');
   console.log(date, 'date');
   console.log(DateToday());
   const today = DateToday();
   console.log(today);
   if (bookings.bookingNo === 0) {
      return 0;
   } else {
      let periodStart = new Date(today.year, today.month, today.day, 9, 0);
      let periodEnd = new Date(today.year, today.month, today.day, 18, 0);
      let timeUsed = 0;
      if (Number(date.ref) == Number(today.ref)) {
         periodStart = new Date();
      }
      Object.entries(bookings.bookings).map(([key, value]) => {
         if (Number(date.ref) == Number(today.ref)) {
            if (value.start.toDate() > new Date()) {
               timeUsed =
                  timeUsed + diff_minutes(value.end.toDate(), value.start.toDate());
            }
            if (value.start.toDate() < new Date() && value.end.toDate() > new Date()) {
               timeUsed = timeUsed + diff_minutes(new Date(), value.end.toDate());
            }
         } else {
            timeUsed = timeUsed + diff_minutes(value.end.toDate(), value.start.toDate());
         }
      });
      console.log(timeUsed, 'used');
      let availability = diff_minutes(periodEnd, periodStart);
      let cap = (timeUsed / availability) * 100;
      console.log(cap, 'cap');

      if (cap < 30) {
         return 1;
      } else if (cap >= 30 && cap < 50) {
         return 2;
      } else if (cap >= 50 && cap < 75) {
         return 3;
      } else if (cap >= 75 && cap < 80) {
         return 4;
      } else {
         return 5;
      }
   }
}

export const naturalCompare = (a, b) => {
   const chunkRegex = /(\d+)|(\D+)/g;
   const ax = a.match(chunkRegex);
   const bx = b.match(chunkRegex);

   while (ax && bx && ax.length > 0 && bx.length > 0) {
      const chunkA = ax.shift();
      const chunkB = bx.shift();

      if (chunkA !== chunkB) {
         const numA = parseInt(chunkA, 10);
         const numB = parseInt(chunkB, 10);

         if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
         }
         return chunkA.localeCompare(chunkB);
      }
   }

   return a.localeCompare(b);
};

/**
 * Space date availability utilities.
 *
 * Pure functions with zero external dependencies — can be copied
 * directly into the legacy app if needed.
 *
 * Date strings use the project's YYYYMMDD format with zero-based months
 * (matching Day.ref / booking document IDs).
 */

/**
 * Convert a Date to a YYYYMMDD ref string (zero-based month).
 *
 * Example: new Date(2026, 2, 22) → "20260222"
 *          (March is month 2 in JS, kept as-is)
 */
export function dateToRef(d) {
   const yyyy = d.getFullYear();
   const mm = String(d.getMonth()).padStart(2, '0');
   const dd = String(d.getDate()).padStart(2, '0');
   return `${yyyy}${mm}${dd}`;
}

/**
 * Convert a YYYYMMDD ref string (zero-based month) back to a Date.
 *
 * Example: "20260222" → new Date(2026, 2, 22)  (March 22)
 */
export function refToDate(ref) {
   const year = parseInt(ref.slice(0, 4), 10);
   const month = parseInt(ref.slice(4, 6), 10); // already zero-based
   const day = parseInt(ref.slice(6, 8), 10);
   return new Date(year, month, day);
}

/**
 * Check whether a space should be visible on a given date.
 *
 * @param spaceData - The space document data (must have optional bookableFrom / bookableUntil strings)
 * @param dateRef   - The YYYYMMDD ref string for the schedule date being viewed
 * @returns true if the space should be shown, false if it should be hidden
 *
 * Rules:
 *  - If bookableFrom is set and dateRef < bookableFrom → hidden (too early)
 *  - If bookableUntil is set and dateRef > bookableUntil → hidden (too late)
 *  - Otherwise → visible
 *  - Empty/undefined fields mean no restriction on that end
 */
export function isSpaceAvailableOnDate(spaceData, dateRef) {
   if (spaceData.bookableFrom && dateRef < spaceData.bookableFrom) {
      return false;
   }
   if (spaceData.bookableUntil && dateRef > spaceData.bookableUntil) {
      return false;
   }
   return true;
}
